import { render, staticRenderFns } from "./PayPalButton.vue?vue&type=template&id=df1922ce&scoped=true"
import script from "./PayPalButton.vue?vue&type=script&lang=js"
export * from "./PayPalButton.vue?vue&type=script&lang=js"
import style0 from "./PayPalButton.vue?vue&type=style&index=0&id=df1922ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1922ce",
  null
  
)

export default component.exports